import { HDate } from "@hebcal/core";

/**
 * Pure Hebrew date: day (gematriya) + "ב" + month + year prefixed with "ה'".
 * Example: "כה בניסן ה'תשפ״ו"
 */
export function formatHebrewDate(d: Date): string {
  const hd = new HDate(d);
  const full = hd.renderGematriya(true); // e.g. "כה ניסן תשפ״ו"
  const parts = full.split(" ");
  if (parts.length < 3) return full;
  const [day, ...monthAndYear] = parts;
  const year = monthAndYear.pop()!;
  const month = monthAndYear.join(" ");
  return `${day} ב${month} ה'${year}`;
}
